import CloseIcon from '@mui/icons-material/Close'
import {
  CircularProgress,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@mui/material'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { MentorUpcomingPastEventsTable } from 'src/mentor/components/MentorEventsPage/MentorEventsComponentsAndHelpers'
import {
  getPriceStringWithCurrency,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import { prepareBookedEventsDataFromApiResponse as prepareBookedEventsDataFromApiResponseUtils } from './invoiceDetailsUtils'
import MultiplePictureUploadButton from 'src/consumer/components/Helpers/PictureUploadButton/MultiplePictureUploadButton'

export default function InvoiceDetailsDialog({
  open,
  onClose,
  invoice: propInvoice,
  bookedEventsListingApiSignature,
  prepareBookedEventsDataFromApiResponse = prepareBookedEventsDataFromApiResponseUtils,
}) {
  const [invoice, setInvoice] = useState(propInvoice)

  const paymentInfo = invoice?.paymentInfo
  const [attachedBookedEvents, setAttachedBookedEvents] = useState([])
  const [loading, setLoading] = useState(false)
  async function getAttachedBookedEvents() {
    setLoading(true)
    const resp = await getSPDataWithParams(bookedEventsListingApiSignature, {
      'invoice-id': invoice?.id,
      bookedEventIds: invoice?.includedBookedEventIds?.join(','),
      page: 0,
      size: 1000,
    })
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        setAttachedBookedEvents(prepareBookedEventsDataFromApiResponse(resp))
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    if (!!invoice?.includedBookedEventIds && invoice?.includedBookedEventIds?.length > 0) {
      getAttachedBookedEvents()
    }
  }, [invoice])

  return (
    <>
      <DialogTitle>
        Payment Details
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography fontWeight={600} variant="subtitle1">
              Paid On
            </Typography>
            <Typography>
              {paymentInfo?.paidOn ? dayjs(paymentInfo?.paidOn).format('DD MMM YYYY') : '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography fontWeight={600} variant="subtitle1">
              Amount Paid
            </Typography>
            <Typography>
              {paymentInfo?.amtPaid
                ? getPriceStringWithCurrency(paymentInfo?.amtPaid, paymentInfo?.currencyCode)
                : '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography fontWeight={600} variant="subtitle1">
              Retainer Amount
            </Typography>
            <Typography>
              {paymentInfo?.retainerAmt
                ? getPriceStringWithCurrency(paymentInfo?.retainerAmt, paymentInfo?.currencyCode)
                : '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography fontWeight={600} variant="subtitle1">
              Minimum Payout
            </Typography>
            <Typography>
              {paymentInfo?.minimumPayout
                ? getPriceStringWithCurrency(paymentInfo?.minimumPayout, paymentInfo?.currencyCode)
                : '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography fontWeight={600} variant="subtitle1">
              Payment Transaction ID
            </Typography>
            <Typography>{paymentInfo?.paymentTxnId ? paymentInfo?.paymentTxnId : '-'}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography fontWeight={600} variant="subtitle1">
              Payment Comments
            </Typography>
            <Typography>{paymentInfo?.comments ? paymentInfo?.comments : '-'}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography fontWeight={600} variant="subtitle1">
              Supporting Images
            </Typography>
            <MultiplePictureUploadButton imageIds={paymentInfo?.supportingImages} disabled />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <span style={{ fontWeight: 600 }}>Events Recorded for this invoice</span>
          </Grid>
          <Grid item xs={12}>
            {loading ? (
              <CircularProgress />
            ) : (
              <MentorUpcomingPastEventsTable
                allEvents={attachedBookedEvents}
                showMentorName
                hideActions
                hideAllActions
                hideRefreshButton={true}
              />
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </>
  )
}
